var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"posts"},[_c('h1',[_vm._v("Posts")]),_vm._v("\n  This file will list all the posts.\n\n  "),_vm._l((_vm.posts),function(post){return _c('div',[_c('p',[_c('span',[_c('b',[_vm._v(_vm._s(post.random))])]),_c('br')])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d97bff9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posts.vue
// module id = 164
// module chunks = 1